import { Channel } from '@/constants/earning-channels'

export const Colors = {
  [Channel.Subscriptions]: '#3467FF',
  [Channel.Tips]: '#2fc25b',
  [Channel.Posts]: '#FF6868',
  [Channel.Messages]: '#FF9C6E',
  [Channel.Referrals]: '#35C2FF',
  [Channel.Streams]: '#CA34FF',
}

export type ColorKeys = keyof typeof Colors